import collapse from '../../../../../utils/collapse-whitespace'
import prettify from 'pretty'
import { createEditor, Transforms, Editor, Path, Node } from 'slate'
import { applyPlugins } from '../applyPlugins'
import { htmlSanitizer } from '..'
import { fromRedactor } from './fromRedactor'
import { toRedactor } from './toRedactor'
import { isNotFormattedElement } from './utils'

export const transformInvalidNestedLists = (html: HTMLElement) => {
  const invalidLists = Array.from(html.querySelectorAll(`ol > ol, ol > ul, ul > ol, ul > ul`))

  for (let list of invalidLists) {
    const previousListItem = list.previousElementSibling
    if (!previousListItem) return
    previousListItem.appendChild(list)
  }
}

export function htmlToJson(htmlValue: any, allowExtraTags?: any, config?: any) {
  let parsedHtml = htmlSanitizer(htmlValue)
  collapse(parsedHtml, undefined, isNotFormattedElement)
  parsedHtml.normalize() // remove empty text nodes

  transformInvalidNestedLists(parsedHtml)

  const slateJson = [
    {
      type: 'docs',
      children: fromRedactor(parsedHtml, allowExtraTags, config)
    }
  ]


  const mergeConsecutiveFragments = (json: any[]) => {
    const editor = applyPlugins(createEditor())
  
    editor.children = json

    const pathsToMerge = Array.from(
      Editor.nodes(editor, {
        at: [],
        match: (n: any, path) => {
          if (n.type !== 'fragment') return false
          if (!Path.hasPrevious(path)) return false
          const prevNode: any = Node.get(editor, Path.previous(path))
          return prevNode?.type === 'fragment'
        }
      })
    ).map(([, path]) => path)

  
    Editor.withoutNormalizing(editor, () => {
      for (const path of pathsToMerge.reverse()) {
        Transforms.mergeNodes(editor, { at: path })
      }
    })

    return editor.children
  }

  const mergedJson = mergeConsecutiveFragments(slateJson)
  return mergedJson

}

export function jsonToHtml(slateDoc) {
  return prettify(toRedactor(slateDoc))
}
